<template>
  <Chart ref="highchartsRef" :options="chartOptions" />
</template>

<script lang="ts" setup>
import { ref, onBeforeMount, onMounted } from 'vue';

import { Options, SeriesOptionsType } from 'highcharts';
import { Chart } from 'highcharts-vue';
import {
  configureBarChartOptions,
  configureBarChartAllocationOptions
} from './helpers';

interface Props {
  labels: string[];
  series: SeriesOptionsType[];
  height?: string;
  maxAxisY?: number;
  useAllocationOptions?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  height: '450',
  maxAxisY: undefined,
  useAllocationOptions: false
});

const highchartsRef = ref();
const chartOptions = ref<Options>();

function setChartOptions() {
  chartOptions.value = props.useAllocationOptions
    ? configureBarChartAllocationOptions(props.series)
    : configureBarChartOptions(props.series, props.labels, props.maxAxisY);
}

onBeforeMount(() => {
  // prevent chart flick
  chartOptions.value = {
    chart: {
      height: props.height
    }
  };
});

onMounted(() => {
  setChartOptions();
});
</script>
